import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';

import ContatoBlockData from './Data';
import ContatoBlockView from './View';

const ContatoBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <ContatoBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <ContatoBlockData
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(ContatoBlockEdit);
